var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"product-distributor"},[_c('dealer-information',{staticStyle:{"margin-bottom":"2rem"},attrs:{"list":_vm.maintenanceDistribution}}),_c('service-details',{attrs:{"list":_vm.maintenanceDistribution}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }